import InfoBlockValueAttribute from "../band_page/InfoBlockValueAttribute";
import ListTags from "../ListTags";
import BlankProfileImage from "../../assets/fallback/artist_fallback.webp";

const BlogPostMeta = ({ data }) => {
  const postedByType = String(
    data?.blogpost?.posted_by_type || "",
  ).toLowerCase();
  const postedByBasePath = ["organizer", "organiser", "organization"].includes(
    postedByType,
  )
    ? "/orgs"
    : "/music";
  const postedByUrl = data
    ? `${postedByBasePath}/${data.blogpost.posted_by_slug}`
    : "";
  const profileImage = data.blogpost.posted_by_profile_image
    ? data.blogpost.posted_by_profile_image
    : BlankProfileImage;
  const profileImageAlt = data
    ? `Författaren, ${data.blogpost.posted_by_name}'s profilbild`
    : "";

  return (
    <div className="bg-[#131313] border border-white/10 rounded-2xl w-full p-6 my-6 shadow-lg flex flex-col md:flex-row gap-6 items-center md:items-start">
      <div className="w-full md:w-auto flex-shrink-0">
        <a href={postedByUrl}>
          <img
            className="rounded-2xl size-32 border border-white/10 object-cover mx-auto md:mx-0 shadow-md"
            src={profileImage}
            alt={profileImageAlt}
          />
        </a>
      </div>
      <div className="flex-grow w-full flex flex-col gap-1">
        <div className="flex justify-between items-center py-2.5 border-b border-white/5">
          <span className="text-[10px] font-bold text-stone-400 uppercase tracking-wider">Författare</span>
          <span className="text-sm font-extrabold text-white">
            <a href={postedByUrl} className="hover:text-[#0047ff] transition-colors">
              {data.blogpost.posted_by_name}
            </a>
          </span>
        </div>
        <div className="flex justify-between items-center py-2.5 border-b border-white/5">
          <span className="text-[10px] font-bold text-stone-400 uppercase tracking-wider">Skapat</span>
          <span className="text-sm font-extrabold text-white">{data.blogpost.created_at}</span>
        </div>
        {data.blogpost.updated_at !== data.blogpost.created_at && (
          <div className="flex justify-between items-center py-2.5 border-b border-white/5">
            <span className="text-[10px] font-bold text-stone-400 uppercase tracking-wider">Uppdaterat</span>
            <span className="text-sm font-extrabold text-white">{data.blogpost.updated_at}</span>
          </div>
        )}
      </div>
      {data.blogpost.tags && data.blogpost.tags.length > 0 && (
        <div className="w-full md:w-48 flex-shrink-0 self-stretch flex flex-col justify-between">
          <div>
            <span className="text-[10px] font-bold text-stone-400 uppercase tracking-wider block mb-2">Taggar</span>
            <ListTags tags={data.blogpost.tags} />
          </div>
        </div>
      )}
    </div>
  );
};

export default BlogPostMeta;
